namespace Matrix.Indexation {
    export interface FactIndexationProfileSecurityForm {
        IndexationProfileKey: Serenity.IntegerEditor;
        SecurityKey: Serenity.IntegerEditor;
        IndexKey: Serenity.IntegerEditor;
        DefaultSortOrder: Serenity.IntegerEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class FactIndexationProfileSecurityForm extends Serenity.PrefixedContext {
        static formKey = 'Indexation.FactIndexationProfileSecurity';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!FactIndexationProfileSecurityForm.init)  {
                FactIndexationProfileSecurityForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = StaticTextBlock;
                var w2 = ReadOnlyDateTime;

                Q.initFormType(FactIndexationProfileSecurityForm, [
                    'IndexationProfileKey', w0,
                    'SecurityKey', w0,
                    'IndexKey', w0,
                    'DefaultSortOrder', w0,
                    'CreatedBy', w1,
                    'CreatedWhen', w2,
                    'UpdatedBy', w1,
                    'UpdatedWhen', w2,
                    'Version', w1
                ]);
            }
        }
    }
}
